import { USER_TRACKING_EVENTS } from "@website/tracking/tracking.types";
import { addEventToTracking } from "@website/tracking/user";

export const handleSearchInitiated = (data) => {
  addEventToTracking(USER_TRACKING_EVENTS.GENERAL_SEARCH, {
    product: "villa",
    ...data
  });
};

export const handleEventMapSearchClicked = (data) => {
  addEventToTracking(USER_TRACKING_EVENTS.MAP_SEARCH_CLICKED, {
    product: "villa",
    ...data
  });
};

export const handleCategoryBadgeFilterClicked = (data) => {
  addEventToTracking(USER_TRACKING_EVENTS.BADGE_FILTER_CLICKED, {
    product: "villa",
    ...data
  });
};
